import { Component, Input } from '@angular/core';
import { Question } from '@app/core/models/questionnaire.model';
import { CoreService } from '@app/core/services/core.service';
import { InputText } from '@app/shared/components/form-fields/input-text/input-text';
import { Textarea } from '@app/shared/components/form-fields/textarea/textarea';
import { CommonModule } from '@angular/common';
import { QuestionSubType } from '@app/core/enums/questionnaire.enums';
import { Number } from '@app/shared/components/form-fields/number/number';
import { MobileNumber } from '@app/shared/components/form-fields/mobile-number/mobile-number';
import { DatePicker } from '@app/shared/components/form-fields/date-picker/date-picker';

@Component({
  selector: 'app-text-input',
  imports: [InputText,Textarea,CommonModule,Number,MobileNumber,DatePicker],
  templateUrl: './text-input.html',
  styleUrl: './text-input.scss'
})
export class TextInput {
  @Input() question: Question | null = null;
  questionSubType = QuestionSubType;
  constructor(private coreService: CoreService) {}

}
